class CH2Fragments {
    constructor(_graphicDevice) {
        this.graphicDevice = _graphicDevice;
    }

    vertexFragment() {
        const fragment = `
            attribute vec2 aPosition;
            varying vec2 vUv0;

            void main(void)
            {
                vUv0 = aPosition.xy * 0.5 + 0.5;
                gl_Position = vec4(aPosition, 0.0, 1.0);
            }
        `;
        return fragment;
    }

    normalFragment() {
        const fragment = `
            precision ${this.graphicDevice.precision} float;

            varying vec2 vUv0;

            uniform sampler2D u_texture;

            vec2 resolution = vec2(512.0);

            vec3 gradient(sampler2D sampler, vec2 uv)
            {
                vec3 gradient = vec3(0.0);
                gradient.x = texture2D(sampler, uv + vec2(1.0, 0.0) / resolution).r -
                             texture2D(sampler, uv - vec2(1.0, 0.0) / resolution).r;
                gradient.y = - texture2D(sampler, uv + vec2(0.0, 1.0) / resolution).r +
                             texture2D(sampler, uv - vec2(0.0, 1.0) / resolution).r;
                gradient.z = 1.0;
                return normalize(gradient);
            }
            
            void main(void)
            {
                vec2 uv = vUv0;
                vec3 normal = gradient(u_texture, uv);
                vec3 color = normal * 0.5 + 0.5;
                gl_FragColor = vec4(color, 1.0);
            }
        `;
        return fragment;
    }

    blurFragment() {
        const fragment = `
            precision ${this.graphicDevice.precision} float;

            varying vec2 vUv0;

            uniform sampler2D u_texture;
            uniform bool u_colorinversion;

            vec4 blur(sampler2D tex, vec2 uv) {
                vec2 resolution = vec2(512.0);
                vec4 color = vec4(0.0);
                float weight;
                vec2 offset;
                float totalWeight = 0.0;
                for (int y = -1; y <= 1; y++) {
                    for (int x = -1; x <= 1; x++) {
                        offset = vec2(float(x), float(y)) / resolution;
                        weight = 1.0 / (2.0 * 3.14159265) * exp(-dot(offset, offset) / (2.0));
                        color += texture2D(tex, uv + offset) * weight;
                        totalWeight += weight;
                    }
                }
                color /= totalWeight;
                if (length(offset) == 0.0) {
                    color = color * 0.3 + texture2D(tex, uv) * 0.6;
                }
                return color;
            }
            
            void main(void) {
                vec4 color = blur(u_texture, vUv0);
                if (u_colorinversion) {
                    float depth = 1.0 - color.r < 0.2 ? 0.2 : 1.0 - color.r;
                    color = vec4(depth, depth, depth, 1.0);
                }
                gl_FragColor = color;
            }
        `;
        return fragment;
    }

    copyFragmentJ() {
        const fragment = `
            precision ${this.graphicDevice.precision} float;

            varying vec2 vUv0;

            uniform sampler2D u_texture;
            
            void main(void) {
                gl_FragColor = texture2D(u_texture, vUv0);
            }
        `;
        return fragment;
    }

    opacityFragmentJ() {
        const fragment = `
            precision ${this.graphicDevice.precision} float;

            varying vec2 vUv0;

            uniform sampler2D u_texture;
            
            void main(void) {
                vec4 textureColor = texture2D(u_texture,vUv0);
                gl_FragColor = vec4(1.0 - textureColor.r, 1.0 - textureColor.g, 1.0 - textureColor.b, 1.0);
            }
        `;
        return fragment;
    }

    blurFragmentJ() {
        const fragment = `
            precision ${this.graphicDevice.precision} float;

            varying vec2 vUv0;

            uniform sampler2D u_texture;
            uniform vec2 u_direction;

            vec2 resolution = vec2(512.0);
            
            void main(void) {
                vec4 color = vec4(0.0);
                vec2 off1 = vec2(1.411764705882353) * u_direction;
                vec2 off2 = vec2(3.2941176470588234) * u_direction;
                vec2 off3 = vec2(5.176470588235294) * u_direction;
                color += texture2D(u_texture, vUv0) * 0.1964825501511404;
                color += texture2D(u_texture, vUv0 + (off1 / resolution)) * 0.2969069646728344;
                color += texture2D(u_texture, vUv0 - (off1 / resolution)) * 0.2969069646728344;
                color += texture2D(u_texture, vUv0 + (off2 / resolution)) * 0.09447039785044732;
                color += texture2D(u_texture, vUv0 - (off2 / resolution)) * 0.09447039785044732;
                color += texture2D(u_texture, vUv0 + (off3 / resolution)) * 0.010381362401148057;
                color += texture2D(u_texture, vUv0 - (off3 / resolution)) * 0.010381362401148057;
                gl_FragColor = color;
            }
        `;
        return fragment;
    }

    normalFragmentJ() {
        const fragment = `
            precision ${this.graphicDevice.precision} float;

            varying vec2 vUv0;

            uniform sampler2D u_texture;

            vec2 resolution = vec2(512.0);
            
            void main(void) {
                vec2 step = vec2(-1.0 / resolution.x, -1.0 / resolution.y);
                vec2 tlv = vec2(vUv0.x - step.x, vUv0.y + step.y );
                vec2 lv  = vec2(vUv0.x - step.x, vUv0.y          );
                vec2 blv = vec2(vUv0.x - step.x, vUv0.y - step.y );
                vec2 tv  = vec2(vUv0.x         , vUv0.y + step.y );
                vec2 bv  = vec2(vUv0.x         , vUv0.y - step.y );
                vec2 trv = vec2(vUv0.x + step.x, vUv0.y + step.y );
                vec2 rv  = vec2(vUv0.x + step.x, vUv0.y          );
                vec2 brv = vec2(vUv0.x + step.x, vUv0.y - step.y );
                tlv = vec2(tlv.x >= 0.0 ? tlv.x : (1.0 + tlv.x),  tlv.y >= 0.0 ? tlv.y : (1.0  + tlv.y));
                tlv = vec2(tlv.x < 1.0  ? tlv.x : (tlv.x - 1.0 ), tlv.y < 1.0  ? tlv.y : (tlv.y - 1.0 ));
                lv  = vec2( lv.x >= 0.0 ?  lv.x : (1.0 + lv.x),   lv.y  >= 0.0 ?  lv.y : (1.0  +  lv.y));
                lv  = vec2( lv.x < 1.0  ?  lv.x : ( lv.x - 1.0 ), lv.y  < 1.0  ?  lv.y : ( lv.y - 1.0 ));
                blv = vec2(blv.x >= 0.0 ? blv.x : (1.0 + blv.x),  blv.y >= 0.0 ? blv.y : (1.0  + blv.y));
                blv = vec2(blv.x < 1.0  ? blv.x : (blv.x - 1.0 ), blv.y < 1.0  ? blv.y : (blv.y - 1.0 ));
                tv  = vec2( tv.x >= 0.0 ?  tv.x : (1.0 + tv.x),   tv.y  >= 0.0 ? tv.y  : (1.0  +  tv.y));
                tv  = vec2( tv.x < 1.0  ?  tv.x : ( tv.x - 1.0 ), tv.y  < 1.0  ? tv.y  : ( tv.y - 1.0 ));
                bv  = vec2( bv.x >= 0.0 ?  bv.x : (1.0 + bv.x),   bv.y  >= 0.0 ? bv.y  : (1.0  +  bv.y));
                bv  = vec2( bv.x < 1.0  ?  bv.x : ( bv.x - 1.0 ), bv.y  < 1.0  ? bv.y  : ( bv.y - 1.0 ));
                trv = vec2(trv.x >= 0.0 ? trv.x : (1.0 + trv.x),  trv.y >= 0.0 ? trv.y : (1.0  + trv.y));
                trv = vec2(trv.x < 1.0  ? trv.x : (trv.x - 1.0 ), trv.y < 1.0  ? trv.y : (trv.y - 1.0 ));
                rv  = vec2( rv.x >= 0.0 ?  rv.x : (1.0 + rv.x),   rv.y  >= 0.0 ? rv.y  : (1.0  +  rv.y));
                rv  = vec2( rv.x < 1.0  ?  rv.x : ( rv.x - 1.0 ), rv.y  < 1.0  ? rv.y  : ( rv.y - 1.0 ));
                brv = vec2(brv.x >= 0.0 ? brv.x : (1.0 + brv.x),  brv.y >= 0.0 ? brv.y : (1.0  + brv.y));
                brv = vec2(brv.x < 1.0  ? brv.x : (brv.x - 1.0 ), brv.y < 1.0  ? brv.y : (brv.y - 1.0 ));
                float tl = abs(texture2D(u_texture, tlv).r);
                float l  = abs(texture2D(u_texture, lv ).r);
                float bl = abs(texture2D(u_texture, blv).r);
                float t  = abs(texture2D(u_texture, tv ).r);
                float b  = abs(texture2D(u_texture, bv ).r);
                float tr = abs(texture2D(u_texture, trv).r);
                float r  = abs(texture2D(u_texture, rv ).r);
                float br = abs(texture2D(u_texture, brv).r);
                float dx = tl + l*2.0 + bl - tr - r*2.0 - br;
                float dy = tl + t*2.0 + tr - bl - b*2.0 - br;
                vec3 normal = normalize(vec3(dx * -255.0, dy * 255.0, 50.0));
                gl_FragColor = vec4(normal.xyz * 0.5 + 0.5, 1.0);
            }
        `;
        return fragment;
    }
}

module.exports = CH2Fragments;
